import Model from './model';

export default Model.extend( {

    endpoint: 'users/register',
    
    defaults: {
        login: undefined,
        paswd: undefined,
        role_id: undefined,
        fio: undefined,
        email: undefined,
        passport: undefined,
        phone: undefined,
        address: undefined,
    }
    
} );


// WEBPACK FOOTER //
// ./src/js/model/user.register.js